// Suppress ResizeObserver loop errors from vendor packages (e.g., recharts)
// This is a known browser quirk that occurs when ResizeObserver callbacks trigger
// DOM changes that cause more resize observations. It's never a valid error.
// See: https://github.com/WICG/resize-observer/issues/38
// This override is applied in all environments with a safeguard to detect excessive errors.

if (typeof window !== 'undefined' && window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver

  // Safeguard: Track error frequency to detect potential infinite loops
  const errorTracker = {
    errors: [],
    maxErrorsPerMinute: 100, // Threshold for warning about excessive errors
    cleanupInterval: null,
  }

  // Clean up old error timestamps every minute
  const cleanupOldErrors = () => {
    const oneMinuteAgo = Date.now() - 60000
    errorTracker.errors = errorTracker.errors.filter(
      timestamp => timestamp > oneMinuteAgo,
    )
  }

  // Start cleanup interval
  if (typeof setInterval !== 'undefined') {
    errorTracker.cleanupInterval = setInterval(cleanupOldErrors, 60000)
  }

  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        requestAnimationFrame(() => {
          try {
            callback(entries, observer)
          } catch (error) {
            // Suppress ResizeObserver loop errors (benign browser quirk)
            if (
              error?.message?.includes(
                'ResizeObserver loop completed with undelivered notifications',
              )
            ) {
              // Safeguard: Track error frequency
              const now = Date.now()
              errorTracker.errors.push(now)
              cleanupOldErrors()

              // Warn if errors exceed threshold (potential infinite loop)
              if (
                errorTracker.errors.length > errorTracker.maxErrorsPerMinute
              ) {
                console.warn(
                  `[ResizeObserver] Excessive loop errors detected (${errorTracker.errors.length} in the last minute). This may indicate a performance issue.`,
                )
              }

              return
            }
            throw error
          }
        })
      })
    }
  }
}
